import { Button } from '@/components/ui/button'
import { Clock } from 'lucide-react'

export function BookingTimeSelection({ flow }: { flow: any }) {
  
  const handleSelectTime = (time: string) => {
    flow.setTime(time)
    flow.setStep(6)
  }

  return (
    <div className="space-y-4 animate-in fade-in slide-in-from-bottom-4">
      <h2 className="text-lg font-semibold flex items-center gap-2">
        <Clock className="w-5 h-5 text-blue-500" />
        Selecione o horário
      </h2>
      
      {flow.busyQuery.isFetching ? (
        <div className="py-8 text-center text-slate-400">Verificando agenda...</div>
      ) : (
        <div className="grid grid-cols-3 gap-2 max-h-[300px] overflow-y-auto pr-2 pb-2">
          {flow.slots.map((time: string) => {
            const isUnavailable = flow.unavailable.has(time)
            const isSelected = flow.time === time

            return (
              <button
                key={time}
                disabled={isUnavailable}
                onClick={() => handleSelectTime(time)}
                className={`py-3 rounded-lg border text-sm font-medium transition-all ${
                  isUnavailable
                    ? 'border-slate-800 bg-slate-900/50 text-slate-600 cursor-not-allowed line-through'
                    : isSelected
                    ? 'border-blue-500 bg-blue-500 text-white shadow-md'
                    : 'border-slate-700 bg-slate-800 text-slate-200 hover:border-blue-400 hover:bg-slate-700'
                }`}
              >
                {time}
              </button>
            )
          })}
        </div>
      )}

      {flow.slots.length > 0 && Array.from(flow.unavailable).length === flow.slots.length && !flow.busyQuery.isFetching && (
        <div className="text-center py-4 text-sm text-red-400 bg-red-400/10 rounded-lg border border-red-400/20">
          Nenhum horário livre neste dia. Tente outra data.
        </div>
      )}

      <div className="pt-4 flex gap-2">
        <Button variant="outline" className="w-full" onClick={() => flow.setStep(4)}>
          Voltar
        </Button>
      </div>
    </div>
  )
}
